interface IconChevronOptions {
    cssClasses? : string
}

export function IconChevron(props : IconChevronOptions) {
    return (
        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" className={props?.cssClasses}>
            <path d="M12.1924 0.544922C12.5487 0.152159 13.1173 0.152159 13.4736 0.544922C13.8423 0.951713 13.8424 1.62162 13.4736 2.02832L7.64258 8.45508C7.28624 8.84784 6.71766 8.84784 6.36133 8.45508H6.35352L0.526367 2.03223C0.157628 1.6255 0.157681 0.955594 0.526367 0.548828C0.882703 0.156065 1.45128 0.156065 1.80762 0.548828L6.81445 6.06348H7.18555L12.1924 0.544922Z" fill="black" stroke="white" stroke-width="0.5" stroke-linejoin="bevel"/>
        </svg>
    );
}
